module.exports = __webpack_public_path__ + "img/leader2.daeacf41.png";